import { toast } from "react-toastify";
import { BasicButton } from "../../../../../../../modules/theme/Component/BasicButton";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { _DocumentAffiliateRecord, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { useEffect, useState } from "react";
import useModal, { MODAL_md, MODAL_XL } from "../../../../../../../modules/theme/Component/hooks/useModal";
import { Modal } from "../../../../../../../modules/theme/Component/Modal";
import { FileInput } from "../../../../../../../modules/theme/Component/FileInput";
import { FileService } from "../../../../../../../core/services/FileService";
import { DocumentViewer } from "../../../../../../../modules/theme/Component/DocumentViewer";
import { Alert } from "../../../../../../../modules/theme/Component/Alert";
import { PrintJson } from "../../../../../../../modules/theme/Component/PrintJson";

interface PersonalDocumentsTabProps {
    idAccount?: number;
    type?: number[];
    _loanLine?: number;
    _payrollType?: number;
    updateAffiliate: Function;
    cannotEdit?: boolean;
}

export const PersonalDocumentsTab = ({ idAccount, updateAffiliate, type, _loanLine, _payrollType, cannotEdit }: PersonalDocumentsTabProps) => {
    const _documentAffiliateRecord = useDataBean(_DocumentAffiliateRecord);
    const { bean, setBean, lista, setLista, instance } = _documentAffiliateRecord;
    const modalCargar = useModal("Documento", MODAL_md);
    const modalDocs = useModal("Documento", MODAL_XL);
    const [file, setFile] = useState<any>({});
    const [docs, setDocs] = useState<any>([]);
    const files = new FileService();

    useEffect(() => {
        getDocumentCreditByAffiliate(idAccount ?? _single.getAccountID());
    }, [idAccount]);

    useEffect(() => {
        if (file.Media) {
            if (!bean.IDDocumentAffiliateRecord) delete bean.IDDocumentAffiliateRecord;

            let temp = {
                ...bean,
                "MediaDoc": file.Media,
                "MediaContext": file.MediaContext,
                "DocumenName": file.Name,
                "IDAccount": idAccount
            };

            instance.updateDocumentAffiliateRecord(temp).then(() => {
                modalCargar.close();
                getDocumentCreditByAffiliate(idAccount ?? _single.getAccountID());
            });
        }
    }, [file]);

    const getDocumentCreditByAffiliate = (idAcc: number) => {

        instance.getDocumentCreditByAffiliate(idAcc).then((resp: any) => {
            const documentos = resp.filter((item) => {
                const { JSONPayRollEntity, JSONLoanLine, RoleSubmit, State } = item.DataBeanProperties;

                if (State !== 1) return false;

                try {
                    // Paso 1: Validar tipo de usuario (siempre)
                    if (!type.includes(RoleSubmit)) {
                        console.warn("Documento excluido por tipo de usuario", { RoleSubmit, type, item });
                        return false;
                    }

                    // Paso 2: Validar por PayrollType solo si hay elementos
                    if (JSONPayRollEntity) {
                        const payrollList = JSON.parse(JSONPayRollEntity);
                        if (payrollList.length > 0) {
                            const payrollMatch = payrollList.some(
                                (entry: any) => entry.PayrollType == _payrollType
                            );
                            if (!payrollMatch) {
                                console.warn("Documento excluido por PayRollEntity", { _payrollType, item });
                                return false;
                            }
                        }
                    }

                    // Paso 3: Validar por LoanLine solo si hay elementos
                    if (JSONLoanLine) {
                        const loanLineList = JSON.parse(JSONLoanLine);
                        if (loanLineList.length > 0) {
                            if (!_loanLine || !loanLineList.some((entry: any) => entry.loanLine == _loanLine)) {
                                console.warn("Documento excluido por LoanLine", { _loanLine, item });
                                return false;
                            }
                        }
                    }

                    // Todos los filtros pasaron
                    return true;

                } catch (e) {
                    console.error("Error parseando JSONPayRollEntity o JSONLoanLine", e, item);
                    return false;
                }
            });

            setLista(documentos);
        });
    };


    const handleSave = () => {
        updateAffiliate();
        toast.success("Documentos guardados correctamente.");
    };

    const actualizarDocumento = (row: any) => {
        setBean(row);
        modalCargar.open();
    };

    const verDocumento = (row: any) => {
        let tem = { ...row };
        tem.DataBeanProperties.Media = tem.DataBeanProperties.MediaDoc;
        tem.DataBeanProperties.Filename = tem.DataBeanProperties.MediaDoc;
        tem.DataBeanProperties.Type = "pdf";
        tem.DataBeanProperties.URLLink = files.getUrlFile(row.DataBeanProperties.MediaContext, row.DataBeanProperties.MediaDoc);
        setDocs([tem]);
        modalDocs.open();
    };

    return (
        <div className="row">
            <h4>Documentos</h4>
            <div className="row mt-4">
                <div className="col-md-12">
                    {lista.length === 0 ? (
                        <Alert children={`No se encontraron documentos disponibles.`} clase="warning text-center" />
                    ) : (
                        <ul className="list-group">
                            {lista.map((row: any, index) => (
                                <li key={index} className="list-group-item">
                                    <div className="row">
                                        <div className="col-md-10">
                                            <p>
                                                <strong>{row.DataBeanProperties.DocumenName}</strong> <br />
                                                <small>{row.DataBeanProperties.MediaDoc}</small> <br />
                                                {row.DataBeanProperties.MediaDoc && (
                                                    <span className="link text-primary" onClick={() => verDocumento(row)}>
                                                        Ver Documento
                                                    </span>
                                                )}
                                            </p>
                                        </div>
                                        {!cannotEdit &&
                                            <div className="col-md-2">
                                                <span
                                                    className="link text-primary cursor"
                                                    onClick={() => actualizarDocumento(row.DataBeanProperties)}
                                                >
                                                    Cargar/Actualizar
                                                </span>
                                            </div>
                                        }
                                    </div>
                                </li>
                            ))}
                        </ul>
                    )}

                    <Modal modal={modalCargar.modal} updateModal={modalCargar.setModal}>
                        <FileInput docAcept="application/pdf" directory="credito" onCreate={setFile} />
                    </Modal>
                    <Modal modal={modalDocs.modal} updateModal={modalDocs.setModal}>
                        <DocumentViewer list={docs} />
                    </Modal>
                </div>

                {!cannotEdit &&
                    <div className="col-md-12 mt-4">
                        <BasicButton
                            eventClick={handleSave}
                            icon="ri-save-line"
                            children="Guardar"
                        />
                    </div>
                }
            </div>
        </div>
    );
};
